export { default } from './XifinDocumentUpload';
